<template>
    <div class="detail-2022">
        <div class="header">
            <img :src="detail.imgurl" alt="">
        </div>
        <div class="body">
            <div class="tabs">
                <div :class="[active==item.id?'active':'','tab']" @click="active = item.id" v-for="item in tablist" :key="item.id">{{item.name}}</div>
            </div>
            <div class="centent">
                <div class="html">
                    <template v-if="active==1">
                        <div class="draw" v-if="acid" @click="godraw"></div>
                        <div class="sublist">
                            <div class="citem" @click="godetail(item)" v-for="item in sublist">
                                <div class="tt">
                                    <div>{{item.title}}</div>
                                    <div><van-icon name="clock-o" />{{item.start_time_show}} ~ {{item.end_time_show}}</div>
                                </div>
                                <div class="img"></div>
                            </div>
                        </div>
                    </template>
                        
                    <div v-if="active==2" v-html="detail.rule"></div>
                </div>
            </div>
            <div class="foot" v-if="sublist.length == 1">
                <img @click="godetail(sublist[0])" src="https://oss.mcloud.moveclub.cn/alphamovecloud/20221027/1666841086/532733.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
import "./index.less";
export default {
    props: ["item_id", "sports_id","acid"],
    data() {
        return {
            detail: {},
            tablist: [
                {
                    id: 1,
                    name: '活动列表'
                },{
                    id: 2,
                    name: '活动规则'
                }
            ],
            sublist: [],
            active: 1
        };
    },
    methods: {
        godraw() {
            this.$router.push({name:'luckdraw',params:{'acid':this.acid}})
        },
        godetail(item) {
            this.$router.push({name:'sportsDetail',params:{'sports_id':item.sports_id,'item_sub_id':item.id}})
        },
        init: function () {
            this.$toast.loading({
                duration: 0,
            });
            let params = { itemid: this.item_id };
            this.$api.sports.getItemSubst(params).then(
                (res) => {
                    this.detail = res.data
                    this.sublist = res.data.list
                    this.$toast.clear();
                },
                () => {
                    this.$toast.clear();
                }
            );
        },
    },
    mounted() {
        this.init();
    },
}
</script>